import {
  ChangeDetectorRef,
  Directive,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthStore } from '@store';

@Directive({
  selector: '[appHideForRsaUser]',
  standalone: true,
})
export class HideForRsaUserDirective implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authStore: AuthStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.authStore
      .isRsaUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isRsaUser) => {
        this.updateView(isRsaUser);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private updateView(isRsaUser: boolean): void {
    this.viewContainer.clear();
    if (!isRsaUser) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    this.cdr.detectChanges();
  }
}
